import React from 'react';
import {Grid, Typography} from "@mui/material";
import Step from "../components/ncp/Step";
import useKozelNcpStyles from "../styles/ncp/kozel_ncp";
import MixTapan from "../components/ncp/MixTapan";
import FormSection from "../components/ncp/FormSection";
import {isBeforeAugust31} from "../utils/dateTimesUtils";
import p1 from '../assets/images/ncp/2025/p1.png';
import p2 from '../assets/images/ncp/2025/p2.png';
import p3 from '../assets/images/ncp/2025/p3.png';
import p4 from '../assets/images/ncp/2025/p4.png';

const KozelNcp: React.FC = () => {
    const kozelNcpStyles = useKozelNcpStyles();

    return (
        <Grid container>
            <Grid item xs={12}>
                <MixTapan/>
            </Grid>
           {isBeforeAugust31() &&
    <Grid item xs={12}>
        <Grid container spacing={2} style={{marginTop: '20px', textAlign: 'center'}}>
            <Grid item md={3} xs={6}>
                <img src={p1} alt={'Premiul 1'} style={{
                    width: window.innerWidth >= 900 ? '95%' : '95%', 
                    height: window.innerWidth >= 900 ? '95%' : '95%'
                }}/>
            </Grid>
            <Grid item md={3} xs={6}>
                <img src={p2} alt={'Premiul 2'} style={{
                    width: window.innerWidth >= 900 ? '95%' : '95%', 
                    height: window.innerWidth >= 900 ? '95%' : '95%'
                }}/>
            </Grid>
            <Grid item md={3} xs={6}>
                <img src={p3} alt={'Premiul 3'} style={{
                    width: window.innerWidth >= 900 ? '95%' : '95%', 
                    height: window.innerWidth >= 900 ? '95%' : '95%'
                }}/>
            </Grid>
            <Grid item md={3} xs={6}>
                <img src={p4} alt={'Premiul 4'} style={{
                    width: window.innerWidth >= 900 ? '95%' : '95%', 
                    height: window.innerWidth >= 900 ? '95%' : '95%'
                }}/>
            </Grid>
        </Grid>
        <Grid item xs={12}>
            <Typography className={kozelNcpStyles.textBeforeFormSection}>Selectează magazinul din care ai
                achiziționat produsele Kozel Premium și Kozel Dark și introdu bonul fiscal:</Typography>
        </Grid>
        <Grid item xs={12}>
            <FormSection/>
        </Grid>
    </Grid>
}
        </Grid>
    );
}

export default KozelNcp;